import { normalizeTime, scheduleErrors } from '../Schedule/schedule';

export function offeredSchedule(dates = [], from = '', to = '', slots = []) {
  const byDate = new Map((slots || []).map(slot => [slot.date, slot]));
  return [...new Set(dates)].sort().map(date => ({date, ...normalizeTime(byDate.get(date) || {time_from: from, time_to: to})}));
}
export function broadcastSlots(dates = [], from = '', to = '', slots) {
  const result = { offered_dates: [...new Set(dates)].sort(), offered_time_from: from || '00:00', offered_time_to: to || '23:59:59' };
  if (slots !== undefined) {
    const rows = offeredSchedule(dates, from, to, slots);
    const lower = rows.map(slot => slot.time_from || '00:00').sort();
    const upper = rows.map(slot => slot.time_to || '23:59:59').sort();
    result.offered_slots = rows.map(slot => ({...slot, time_from: slot.time_from || null, time_to: slot.time_to || null}));
    result.offered_time_from = lower[0] || '00:00';
    result.offered_time_to = upper.at(-1) || '23:59:59';
  }
  return result;
}
export function broadcastSlotErrors(dates, from, to, slots) {
  const errors = {};
  if (!Array.isArray(dates) || dates.length === 0 || dates.length > 60) errors.offeredDates = 'Выберите от 1 до 60 предлагаемых дней';
  else if (dates.some(day => !/^\d{4}-\d{2}-\d{2}$/.test(day) || Number.isNaN(new Date(`${day}T00:00:00Z`).getTime()) || new Date(`${day}T00:00:00Z`).toISOString().slice(0, 10) !== day)) errors.offeredDates = 'Проверьте предлагаемые даты';
  if (slots !== undefined) {
    const problem = scheduleErrors({desired_time: 'pick_dates', desired_slots: offeredSchedule(Array.isArray(dates) ? dates : [], from, to, slots)});
    if (problem) errors.offeredTimes = problem;
  } else {
    const values = broadcastSlots(Array.isArray(dates) ? dates : [], from, to);
    if (values.offered_time_from > values.offered_time_to) errors.offeredTimes = 'Конец окна раньше начала';
  }
  return errors;
}
